import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import { DateRangePicker, SingleDatePicker, DayPickerRangeController, } from 'react-dates';
import * as moment from 'moment';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing
interface LocalState extends State {
    battid?: number;
}

// style
const style = css`
    .legend-line {
        ${mixin.legend}
    }
`;
const toolbarStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .usage {
        width: 150px;
        white-space: nowrap;
        margin-left: 1em;
        i {
            float: left;
            font-size: 42px;
            padding-right: 10px;
        }
        strong {
            display: block;
            font-size: 22px;
        }
        span {
            display: block;
            font-size: 14px;
        }
    }
`;

// component
export class Charge extends Proto<Props, LocalState> {

    state = {
        battid: -1,
        startDate: moment().subtract(14, 'days'),
        // startDate: moment('2018-01-01'),
        endDate: moment()
    } as LocalState;

    currCycle = null;

    async componentWillMount() {
        this.loadWithFilters(this.state);
    }

    parseGraphData = ( ) => {
        const { data } = this.state;
        const { socdata } = data.data;
        return socdata.map( v => {
            const { date, soc, lineColor, cycle } = v;
            return {
                date: moment(date).toDate(),
                val: soc,
                lineColor,
                cycle
            }
        });
    }

    gotoCycleDetail = ( ev ) => {

        try{

            let cycleid = this.currCycle;
            if (cycleid === undefined || cycleid === null) {
                console.log("cycleid is null");
                return;
            }

            location.href = "/battery/cycle?id=" + this.state.data.data.battid + "&cycleid=" + cycleid;
        } catch (ex) {

        }
    }

    setBalloonAndCycle = ( ev ) => {

        try{

            this.currCycle = ev.serialDataItem.dataContext.cycle;
            console.log(this.currCycle);

            var cycleData = "";
            var theCycle = ev.serialDataItem.dataContext.cycle;
            if ( theCycle != null) {
                console.log("Go to cycle " + theCycle + " details");
                cycleData = "<br />Cycle: <b>" + theCycle + "</b>";
            }
            return "<div style='margin:5px;'>SOC: <b>" + ev.values.value +"</b>" + cycleData + "</div>";
        } catch (ex) {
            console.log(ex);
        }

        return "";

    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const { last_state } = data;

        const config = {
                "type": "serial",
                "theme": "light",
                "marginLeft": 10,
                "marginRight": 10,
                "balloon": {
                    "cornerRadius": 6,
                    "horizontalPadding": 15,
                    "verticalPadding": 10,
                    "hideBalloonTime": 1000, // 1 second
                    "disableMouseEvents": false, // allow click
                    "fixedPosition": true,
                },
                "graphs": [{
                    "balloonText": "<div style='margin:5px;'>SOC: <b>[[val]]</b><br />Cycle: <b>[[cycle]]</b></div>",
                    "bullet": "square",
                    "bulletBorderAlpha": 1,
                    "bulletBorderThickness": 1,
                    "hideBulletsCount": 50,
                    "fillAlphas": 0.3,
                    "fillColors": vars.colors.grey,
                    "lineColor": vars.colors.grey,
                    "fillColorsField": "lineColor",
                    "legendValueText": "[[value]]",
                    "lineColorField": "lineColor",
                    "title":'',
                    "valueField": "val",
                    "balloonFunction": this.setBalloonAndCycle
                }],
                "chartScrollbar": {
                },
                "chartCursor": {
                    "categoryBalloonDateFormat": "HH:NN",
                    "cursorAlpha": 0,
                    "fullWidth": true,
                    "balloonPointerOrientation": "vertical"
                },
                /*"dataDateFormat": "YYYY-MM-DD HH:NN:SS",*/
                "categoryField": "date",
                "categoryAxis": {
                    "minPeriod": "mm",
                    "parseDates": true,
                    "autoGridCount": false,
                    "axisColor": "#555555",
                    "gridAlpha": 0,
                    "gridCount": 15
                },
                "valueAxes": [
                    {
                        "title": '',
                        "minimum": 0,
                        "maximum": 100,
                        "autoGridCount": false,
                        "gridCount": 10
                    }
                ],
                "export": {
                    //"enabled": true
                },
                "dataProvider": this.parseGraphData(),
                "listeners": [
                    {
                        "event": "clickGraph",
                        "method": this.gotoCycleDetail
                    }
                ]
        };




		const toolbar = () => (
            <div className={toolbarStyle}>
                <DateRangePicker {...this.DatePickerProps()} />
            </div>
		);
        
		return (
            <Box
                title={_('charge_title', 'BatteryOverview')}
                toolbar={toolbar}
                collapsed={false}
                nodata={data.data.socdata.length === 0}
            >
                <div className={style}>
                    <AmCharts.React style={{ width: "100%", height: "400px" }} options={config} />
                    <div className="legend-line">
                        <span className="lgnd-blue">{_('charge_graph_discharge', 'BatteryOverview')}</span>
                        <span className="lgnd-green">{_('charge_graph_completed', 'BatteryOverview')}</span>
                        <span className="lgnd-orange">{_('charge_graph_running', 'BatteryOverview')}</span>
                        <span className="lgnd-red">{_('charge_graph_charge', 'BatteryOverview')}</span>
                        <span className="lgnd-grey">{_('charge_graph_unused', 'BatteryOverview')}</span>
                    </div>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryOverview/Charge.tsx